export const multiWordInitials = (string) =>
  string
    .split(/\s+/)
    .map((word) => word.trim())
    .filter(Boolean)
    .map((word) => word.substring(0, 1).toUpperCase())
    .slice(0, 2)
    .join('')
